module.exports = __webpack_public_path__ + "img/icon-calendar.12be0891.svg";